function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var genStatusStyle = function genStatusStyle(token) {
  var componentCls = token.componentCls,
    menuCls = token.menuCls,
    colorError = token.colorError,
    colorTextLightSolid = token.colorTextLightSolid;
  var itemCls = "".concat(menuCls, "-item");
  return _defineProperty({}, "".concat(componentCls, ", ").concat(componentCls, "-menu-submenu"), _defineProperty({}, "".concat(menuCls, " ").concat(itemCls), _defineProperty({}, "&".concat(itemCls, "-danger:not(").concat(itemCls, "-disabled)"), {
    color: colorError,
    '&:hover': {
      color: colorTextLightSolid,
      backgroundColor: colorError
    }
  })));
};
export default genStatusStyle;